import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

import { DataService } from '../../../../service/data.service';
import { DepositService } from '../../../../service/deposit.service';
import { GtmService } from '../../../../service/gtm.service';

@Component({
    selector: 'app-bonus-restriction',
    templateUrl: './bonus-restriction.component.html',
    styleUrls: ['./bonus-restriction.component.scss'],
    imports: [TranslateModule],
})
export class BonusRestrictionComponent implements OnInit {
    isBwinBe: boolean = false;
    paymentMethod: string;

    constructor(
        private dataService: DataService,
        private depositService: DepositService,
        private gtmService: GtmService,
        private matDialogRef: MatDialogRef<BonusRestrictionComponent>,
    ) {}

    ngOnInit(): void {
        this.isBwinBe = this.dataService?.sessionInfo?.userId?.slice(0, 2) === 'bb';
        this.paymentMethod = this.depositService?.depositInfo?.paymentMethod;
    }

    submitDepositFromPopup(type: any) {
        if (type === 'paypalBonus') {
            this.closeDialog('PayPal_GamingBonusAlert_Yes_Click');
        }
        this.depositService.submitDeposit();
    }

    closeAlertPopup() {
        this.closeDialog('PayPal_GamingBonusAlert_NO_Click');
    }

    closeDialog(clickInfo: string) {
        clickInfo = clickInfo?.toLowerCase();
        this.gtmService.raiseActionEvent('event.functionality.paypalbonusalert', clickInfo);
        this.matDialogRef.close();
    }
}
